module.exports = __webpack_public_path__ + "resources/img/solution_game_migration_m.cd34c21e18dcedb3e819e963e40e5579.png";